import { createSelector } from 'reselect';
import { bannersReducer, BannersSliceType } from './banners.reducer';

export const bannersSliceSelector = (state: any): BannersSliceType => state[bannersReducer.sliceName];

export const isLoadingSliceSelector = createSelector(bannersSliceSelector, (slice: BannersSliceType) => slice.isLoading);

export const bannersSelector = createSelector(bannersSliceSelector, (slice: BannersSliceType) => slice.banners);
